<template>
  <v-dialog v-model="show" persistent :max-width="!isMobile ? 800 : 470">
    <div v-if="!isMobile">
      <v-card>
        <v-card-title class="text-body-1 text-sm-h6">
          <v-icon class="mb-0 mr-2" color="warning">
            mdi-help-circle-outline
          </v-icon>
          {{ $t('changeManagerDialog.title') }}
        </v-card-title>
        <v-spacer></v-spacer>
        <v-card-title class="text-h6 ml-5">
          {{
            $t('changeManagerDialog.subtitle1', {
              managerType: isGroup
                ? $t('changeManagerDialog.managerGroup')
                : $t('changeManagerDialog.managerOperator'),
            })
          }}
          <br />
          {{
            $t('changeManagerDialog.subtitle1name', {
              fullname: fullName,
            })
          }}
          <br />
          <br />
          {{
            $t('changeManagerDialog.subtitle2', {
              managerType: isGroupTarget
                ? $t('changeManagerDialog.managerGroup')
                : $t('changeManagerDialog.managerOperator'),
            })
          }}
          <br />
          {{
            $t('changeManagerDialog.subtitle2name', {
              fullname: fullNameTarget,
            })
          }}
          <br />
          <br />
          {{ $t('changeManagerDialog.subtitle3') }}
        </v-card-title>

        <v-card-text class="text-h7 mt-2">
          {{ $t('changeManagerDialog.message') }}
        </v-card-text>

        <v-card-actions class="mt-4 justify-start">
          <v-spacer></v-spacer>

          <v-btn color="primary" text @click="handleChoice(1)">
            <v-icon dark right> mdi-check </v-icon>
            {{ $t('changeManagerDialog.accept') }}
          </v-btn>

          <v-btn color="error" text @click="handleChoice(2)">
            <v-icon dark left> mdi-close </v-icon
            >{{ $t('changeManagerDialog.cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
    <!-- Modo movil -->
    <div v-else>
      <v-card style="width: 360px">
        <v-card-title class="d-flex align-start">
          <v-icon class="mr-2 mt-1" color="warning">
            mdi-help-circle-outline
          </v-icon>
          <span class="text-body-1 text-sm-h6">
            {{ $t('changeManagerDialog.title') }}
          </span>
        </v-card-title>

        <v-card-text>
          <p>
            {{
              $t('changeManagerDialog.subtitle1Short', {
                managerType: isGroup
                  ? $t('changeManagerDialog.managerGroup')
                  : $t('changeManagerDialog.managerOperator'),
              })
            }}
          </p>

          <p class="font-weight-medium">
            {{
              $t('changeManagerDialog.subtitle1name', {
                fullname: fullName,
              })
            }}
          </p>

          <p>
            {{
              $t('changeManagerDialog.subtitle2', {
                managerType: isGroupTarget
                  ? $t('changeManagerDialog.managerGroup')
                  : $t('changeManagerDialog.managerOperator'),
              })
            }}
          </p>

          <p class="font-weight-medium">
            {{
              $t('changeManagerDialog.subtitle2name', {
                fullname: fullNameTarget,
              })
            }}
          </p>

          <p class="mt-4">
            {{ $t('changeManagerDialog.subtitle3') }}
          </p>

          <p class="mt-3 text-body-2">
            {{ $t('changeManagerDialog.message') }}
          </p>
        </v-card-text>

        <v-card-actions class="justify-center justify-sm-end flex-wrap">
          <v-btn small color="primary" text @click="handleChoice(1)">
            <v-icon dark right> mdi-check </v-icon>
            {{ $t('changeManagerDialog.accept') }}
          </v-btn>

          <v-btn small color="error" text @click="handleChoice(2)">
            <v-icon dark left> mdi-close </v-icon
            >{{ $t('changeManagerDialog.cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    fullName: String,
    isGroup: {
      type: Boolean,
      default: false,
    },
    fullNameTarget: String,
    isGroupTarget: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false, // Inicialmente el diálogo está cerrado
    }
  },
  mounted() {
    // Abrimos el diálogo cuando el componente se monta
    this.show = true
  },
  computed: {
    ...mapGetters(['isMobile']),
  },
  methods: {
    handleChoice(choice) {
      this.$emit('changeManagerChoice', choice == 1 ? 'accept' : 'cancel')
      this.show = false
    },
  },
}
</script>

<style lang="scss" scoped></style>
